import { D as DependencyType } from '../../common-94559169.js';
import '../../configs/index.js';
import { v as v4 } from '../../v4-c5e36445.js';

var generateDependency = function generateDependency(layerId) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DependencyType.STATIC;
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : v4();
  return {
    id: id,
    layerId: layerId,
    type: type
  };
};

export { generateDependency as default };
